import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { Auth0Provider } from "@auth0/auth0-react";
// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

ReactDOM.render(
    <Provider store={store}>
        <Auth0Provider
            domain="finalpoint.us.auth0.com"
            clientId="yhxHorUCmzWvVP2qyfocs4HuxjpxV9qK"
            redirectUri={`${process.env.REACT_APP_ORIGIN}/home`}
            audience={process.env.REACT_APP_AUDIENCE}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Auth0Provider>
    </Provider>,
    document.getElementById('root'));

registerServiceWorker();
